<template>
  <div id="inspire">
    <v-navigation-drawer fixed clipped app>
      <v-list class="pt-1" two-line>
        <v-toolbar flat color="white" light style="border-bottom-style: solid; border-width: 1px; border-color: lightgrey !important;">
          <v-toolbar-title class="text-xs-center">Menu</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <template v-for="(item, i) in menuitems">
          <v-list-tile
            style="border-bottom: 3px solid #dbdbb6;"
            :class="[{active:item.route == route}, {inactive:item.route !== route}]"
            :key="i"
            @click="newpage(item)">
            <v-list-tile-content class="pl-4">
              <v-list-tile-title style="font-size: 16px;" :class="[{activetext:item.route == route}, {inactivetext:item.route !== route}]">
                <v-icon large :color="item.route == route ? 'green' : 'grey'">{{ item.icon }}</v-icon>
                {{ item.text }} ({{ item.number }})
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <router-view class="pt-1 pl-1" style="margin-left: 150px;"></router-view>
    <v-toolbar color="blue darken-3" dark app clipped-left fixed>
      <v-toolbar-title style="width: 300px; min-width: 250px" class="ml-0 pl-3"> <span class="hidden-xs-only">ASP</span> </v-toolbar-title>
        <div class="d-flex align-center" style="margin-left: auto">
          <div class="pr-4"> <span class="hidden-xs-only">-{{this.$store.state.auth.usertype}}-</span> </div>
          <div class="pr-4"> <span class="hidden-xs-only">{{fullname}}</span> </div>
          <div class="pr-5"> <v-btn icon v-on:click="logout"> Log out </v-btn> </div>
        </div>
    </v-toolbar>
  </div>
</template>

<script>

export default {
  computed: {
    menuitems () {
      return this.$store.getters.getMenuitems
    },
    route () {
      return this.$store.getters.getRoute
    },
    fullname () {
      return this.$store.getters.getFullname
    }
  },
  data () {
    return {
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    },
    newpage (i) {
      this.$router.push({
        name: i.route
      })
    }
  },
  mounted () {
  }
}
</script>
<style>
.list__tile__content{
  background-color: white
}
.list__tile{
  padding-right: 0px !important;
  padding-left: 8px;
}
list__tile__title{
  line-height: 50px !important;
}
</style>
<style scoped>
.active{
  background-color: green;
}
.inactive{
  background-color: rgb(232, 243, 224);
}
.activetext{
  color: black;
  line-height: 50px !important;
  height: 50px !important;
}
.inactivetext{
  color: grey;
  line-height: 50px !important;
  height: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue